/* eslint-disable no-useless-escape */
import { ENV } from '@/constants/env'
import UAParser from 'ua-parser-js'
import { api } from '../api'
import { apiNotificationsSubscribes } from '../api/url'
import { LAST_NOTIFICATION_SUBSCRIBE } from '@/constants/localStorageKeys'
import { dayjsWithTz } from './dayjs'
const parser = new UAParser(window.navigator.userAgent)
const parserResults = parser.getResult()

export const safeNotificationInstance =
  'Notification' in window ? Notification : undefined
function urlBase64ToUint8Array(base64String: string) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4)
  const base64 = (base64String + padding).replace(/\-/g, '+').replace(/_/g, '/')

  const rawData = window.atob(base64)
  const outputArray = new Uint8Array(rawData.length)

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i)
  }
  return outputArray
}

export const subsribeNotificationToServer = async (subscription: string) => {
  try {
    if (!localStorage.getItem(LAST_NOTIFICATION_SUBSCRIBE)) {
      await api.post(apiNotificationsSubscribes, {
        subscription,
        userAgent: parserResults.ua,
        osName: parserResults.os.name,
        osVersion: parserResults.os.version,
        deviceModel: parserResults.device.model,
        deviceVendor: parserResults.device.vendor,
        browserName: parserResults.browser.name,
        browserVersion: parserResults.browser.version,
        domain: window.location.host,
      })
      localStorage.setItem(
        LAST_NOTIFICATION_SUBSCRIBE,
        dayjsWithTz().toISOString(),
      )
    }
  } catch (error) {
    console.error(error)
  }
}
export const registerNotificationPermissions = async () => {
  const serviceWorker = await navigator.serviceWorker.ready
  const permission = await safeNotificationInstance?.permission
  if (permission !== 'granted') {
    const request = await safeNotificationInstance?.requestPermission()
    if (request === 'granted') {
      const subscribe = await serviceWorker.pushManager.subscribe({
        applicationServerKey: urlBase64ToUint8Array(
          ENV.NOTIFICATION_PUBLIC_KEY,
        ),
        userVisibleOnly: true,
      })
      subsribeNotificationToServer(JSON.stringify(subscribe))
    }
  }
}
